import { SelectItem } from "@components/Common/Select/types"

const selectEscolta: SelectItem[] = [
    { label: 'Sim', value: true },
    { label: 'Não', value: false },
]

export default selectEscolta